import axios from 'axios'
import { getUrl } from '@/api/utils/http-helpers.js'
/**
 * @param {uri} uri | string
 * @param {data} data | object
 */

export function get (uri) {
  return axios.get(getUrl(uri))
}

export function post (uri, data, opt) {
  return axios.post(getUrl(uri), data, opt)
}

export function put (uri, data) {
  return axios.put(getUrl(uri), data)
}

export function remove (uri, data) {
  return axios.delete(getUrl(uri), data)
}
